<script>
import { Bar } from "vue-chartjs";
import deepmerge from "deepmerge";

import { noDataFoundPlugin } from "../util/no-data-found-charts";
import ChartjsPluginDatalabels from "chartjs-plugin-datalabels";

export default {
  name: "BarChart",
  extends: Bar,
  props: {
    stacked: {
      type: Boolean,
      default: () => false,
    },
    showLegend: {
      type: Boolean,
      default: () => true,
    },
    showLabels: {
      type: Boolean,
      default: () => false,
    },
    chartData: {
      type: Object,
      default: () => null,
    },
    width: {
      type: Number,
      default: () => undefined,
    },
    height: {
      type: Number,
      default: () => undefined,
    },
    aspectRatio: {
      type: Number,
      default: () => 1.6,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: this.aspectRatio,
        legend: {
          display: false,
          position: "bottom",
        },
        scales: {
          xAxes: [
            {
              stacked: this.stacked,
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              stacked: this.stacked,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        plugins: {
          datalabels: {
            display: (context) => {
              const index = context.dataIndex;
              const value = context.dataset.data[index];
              if (!value) {
                return false;
              }

              return this.showLabels ? "auto" : false;
            },
            color: "#fff",
            font(context) {
              const index = context.dataIndex;
              const value = context.dataset.data[index];
              const length = value.toString().length;

              if (length <= 2) {
                return {};
              }

              return {
                size: 10,
              };
              
            }
          }
        }
      },
    };
  },
  computed: {
    shouldShowLegend: function () {
      return (
        this.chartData &&
        this.chartData.datasets &&
        this.chartData.datasets.length > 1 &&
        this.showLegend
      );
    },
  },
  watch: {
    shouldShowLegend (newValue) {
      this.options = deepmerge(this.options, {
        legend: {
          display: newValue,
        },
      });
      this.renderChart(this.chartData || {}, this.options);
    },
    showLabels(newValue) {
      this.options = deepmerge(this.options, {
        plugins: {
          datalabels: {
            display: (context) => {
              const index = context.dataIndex;
              const value = context.dataset.data[index];
              if (!value) {
                return false;
              }

              return newValue ? "auto" : false;
            },
          }
        }
      });
      this.renderChart(this.chartData || {}, this.options);
    },
    chartData: function () {
      this.renderChart(this.chartData || {}, this.options);
    },
  },
  created() {
    this.options = {
      ...this.options,
      legend: {
        ...this.options.legend,
        display: this.shouldShowLegend,
      },
    };
  },
  mounted() {
    this.addPlugin(ChartjsPluginDatalabels);
    this.addPlugin({
      id: "no-data-found",
      afterDraw: (chart) =>
        noDataFoundPlugin(chart, this.chartData, "Nenhum dado encontrado..."),
    });
    this.renderChart(this.chartData || {}, this.options);
  },
};
</script>

<style>
</style>
